import {
	createContext,
	ReactNode,
	useState,
	useCallback,
	useEffect,
} from 'react';
import permissionsData from './permissions.json';
import { useUserRole } from '@/hooks/useUserRole';
import { designationCodes } from '@/utils';

type Role = keyof typeof permissionsData;
type Permission = string;

interface AccessControlContextType {
	hasAccess: (permission: Permission) => boolean;
	// setRole: (role: Role) => void;
}

export const AccessControlContext = createContext<
	AccessControlContextType | undefined
>(undefined);

export const AccessControlProvider = ({
	children,
}: {
	children: ReactNode;
}) => {
	const roleId: keyof typeof designationCodes = useUserRole();
	const [permissions, setPermissions] = useState<Permission[]>(
		permissionsData?.[designationCodes?.[roleId] as Role]?.permissions || [],
	);
	const hasAccess = useCallback(
		(permission: Permission) => permissions.includes(permission),
		[permissions],
	);

	useEffect(() => {
		if (permissions && roleId) {
			setPermissions(
				permissionsData?.[designationCodes?.[roleId] as Role]?.permissions || [],
			);
		}
	}, [roleId]);
	return (
		<AccessControlContext.Provider value={{ hasAccess }}>
			{children}
		</AccessControlContext.Provider>
	);
};
